<template>
  <div class="fixed w-full h-full top-0 left-0 flex items-center justify-center z-50" v-if="isOpen">
    <div class="absolute w-full h-full bg-gray-900 opacity-50" @click="close"></div>
    <div
      class="relative bg-white rounded-xl w-full mx-4 overflow-y-auto"
      style="max-width: 480px; max-height: 90vh"
    >
      <!-- Header -->
      <div class="flex items-center gap-2 px-6 pt-6 pb-4" style="border-bottom: 1px solid #e3e3e3">
        <IconTime class="w-7 h-7" />
        <p class="font-bold text-lg">Time Confirmation</p>
      </div>

      <div class="flex flex-col gap-4 py-4">
        <!-- Status Indicators -->
        <!-- <div
          class="flex items-center justify-between gap-4 px-6 bg-gray-50 py-4"
          v-if="status.isValid || status.isInvalid || status.isPending"
        > -->
        <div class="flex items-center justify-between gap-4 px-6 bg-gray-50 py-4" v-if="false">
          <div class="flex items-center gap-2">
            <div
              v-if="status.isValid"
              class="flex items-center gap-2 px-3 py-2 rounded-lg"
              style="background-color: #ecfdf5; border: 1px solid #d1fae5"
            >
              <svg class="w-5 h-5" viewBox="0 0 20 20" fill="#10b981">
                <path
                  fill-rule="evenodd"
                  d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                  clip-rule="evenodd"
                />
              </svg>
              <p class="text-xs font-bold text-green-700">Sesuai</p>
            </div>
            <div
              v-if="status.isInvalid"
              class="flex items-center gap-2 px-3 py-2 rounded-lg"
              style="background-color: #fdf6ec; border: 1px solid #f57c00"
            >
              <svg class="w-4 h-4" viewBox="0 0 20 20" fill="#F57C00">
                <path
                  fill-rule="evenodd"
                  d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                  clip-rule="evenodd"
                />
              </svg>
              <p class="text-xs font-bold" style="color: #f57c00">Disesuaikan</p>
            </div>
            <div
              v-if="status.isPending"
              class="flex items-center gap-2 px-3 py-2 rounded-lg"
              style="background-color: #fef3c7; border: 1px solid #fde68a"
            >
              <svg
                class="w-5 h-5 animate-spin"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#d97706"
                stroke-width="2"
              >
                <circle cx="12" cy="12" r="10" />
                <path d="M12 6v6l4 2" />
              </svg>
              <p class="text-xs font-bold text-amber-700">Pending</p>
            </div>
          </div>
          <div v-if="customerConfirmedAt || customerConfirmedByName" class="text-right text-xs">
            <p class="text-gray-600">Confirmed by:</p>
            <p class="font-semibold">{{ customerConfirmedByName || '-' }}</p>
            <p class="text-gray-500 text-xs">{{ formatDisplay(customerConfirmedAt) }}</p>
          </div>
        </div>

        <div class="flex flex-col gap-4 px-6">
          <!-- Login Call -->
          <div>
            <p class="font-bold text-sm">Login call</p>
            <p class="text-sm text-gray-500 mt-0.5" v-if="originalDates.loginCall">
              {{ originalDates.loginCall }}
            </p>
            <p class="text-xs font-medium mt-2 mb-1">Correction time</p>
            <input
              type="datetime-local"
              class="input input-bordered w-full"
              :class="errors.loginCall ? 'border-red-400' : ''"
              v-model="form.loginCall"
              @input="touchField('loginCall')"
            />
            <div
              v-if="errors.loginCall"
              class="flex items-start gap-2 mt-2 px-3 py-2 rounded-lg"
              style="background-color: #fff0f0; border: 1px solid #fecaca"
            >
              <img :src="SvgWarning" class="w-4 h-4 mt-0.5 flex-shrink-0" />
              <div>
                <p class="text-xs font-bold text-red-600">Oops</p>
                <p class="text-xs text-red-500">
                  Tanggal dan waktu harus sebelum start &amp; done tiket
                </p>
              </div>
            </div>
          </div>

          <!-- Start -->
          <div>
            <p class="font-bold text-sm">Start</p>
            <p class="text-sm text-gray-500 mt-0.5" v-if="originalDates.start">
              {{ originalDates.start }}
            </p>
            <p class="text-xs font-medium mt-2 mb-1">Correction time</p>
            <input
              type="datetime-local"
              class="input input-bordered w-full"
              :class="errors.start ? 'border-red-400' : ''"
              v-model="form.start"
              @input="touchField('start')"
            />
            <div
              v-if="errors.start"
              class="flex items-start gap-2 mt-2 px-3 py-2 rounded-lg"
              style="background-color: #fff0f0; border: 1px solid #fecaca"
            >
              <img :src="SvgWarning" class="w-4 h-4 mt-0.5 flex-shrink-0" />
              <div>
                <p class="text-xs font-bold text-red-600">Oops</p>
                <p class="text-xs text-red-500">
                  Tanggal dan waktu harus setelah login call &amp; sebelum done tiket
                </p>
              </div>
            </div>
          </div>

          <!-- Done -->
          <div>
            <p class="font-bold text-sm">Done</p>
            <p class="text-sm text-gray-500 mt-0.5" v-if="originalDates.done">
              {{ originalDates.done }}
            </p>
            <p class="text-xs font-medium mt-2 mb-1">Correction time</p>
            <input
              type="datetime-local"
              class="input input-bordered w-full"
              :class="errors.done ? 'border-red-400' : ''"
              v-model="form.done"
              @input="touchField('done')"
            />
            <div
              v-if="errors.done"
              class="flex items-start gap-2 mt-2 px-3 py-2 rounded-lg"
              style="background-color: #fff0f0; border: 1px solid #fecaca"
            >
              <img :src="SvgWarning" class="w-4 h-4 mt-0.5 flex-shrink-0" />
              <div>
                <p class="text-xs font-bold text-red-600">Oops</p>
                <p class="text-xs text-red-500">
                  Tanggal dan waktu harus setelah login call &amp; start tiket
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Buttons -->
      <div class="flex gap-3 px-6 py-4" style="border-top: 1px solid #e3e3e3">
        <button
          class="btn btn-outline rounded-full capitalize h-10 flex-1"
          style="border: 1px solid #000000"
          @click="handleCancel"
        >
          Cancel
        </button>
        <button
          class="btn btn-secondary hover:bg-htealdark rounded-full capitalize h-10 flex-1 hover:border-transparent"
          @click="handleSubmit"
        >
          Submit
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import IconTime from '@/assets/icons/icon-timeColored.svg?inline'
import SvgWarning from '@/assets/icons/icon-warning.svg'

export default {
  name: 'modal-correction-time',
  components: { IconTime },
  data() {
    return {
      SvgWarning,
      form: {
        loginCall: '',
        start: '',
        done: ''
      },
      originalDates: {
        loginCall: '',
        start: '',
        done: ''
      },
      errors: {
        loginCall: false,
        start: false,
        done: false
      },
      touched: {
        loginCall: false,
        start: false,
        done: false
      },
      status: {
        isValid: false,
        isInvalid: false,
        isPending: false
      },
      customerConfirmedAt: '',
      customerConfirmedByName: ''
    }
  },
  computed: {
    isOpen: {
      get() {
        return this.$store.state.modal.correctionTime
      },
      set(value) {
        this.MODAL_CORRECTION_TIME(value)
      }
    },
    ...mapState({
      ticket: state => state.ticket.ticket,
      ticketCorrectionTime: state => state.ticket.ticketCorrectionTime
    })
  },
  watch: {
    async isOpen(val) {
      if (val) {
        this.errors = { loginCall: false, start: false, done: false }
        this.touched = { loginCall: false, start: false, done: false }
        this.originalDates = { loginCall: '', start: '', done: '' }
        this.form = { loginCall: '', start: '', done: '' }
        this.status = { isValid: false, isInvalid: false, isPending: false }
        this.customerConfirmedAt = ''
        this.customerConfirmedByName = ''

        const ct = this.ticketCorrectionTime
        if (ct) {
          this.originalDates.loginCall = this.formatDisplay(ct.login_call_at)
          this.originalDates.start = this.formatDisplay(ct.start_at)
          this.originalDates.done = this.formatDisplay(ct.done_at)

          this.form.loginCall = this.toDatetimeLocal(ct.customer_login_call_at || ct.login_call_at)
          this.form.start = this.toDatetimeLocal(ct.customer_start_at || ct.start_at)
          this.form.done = this.toDatetimeLocal(ct.customer_done_at || ct.done_at)

          this.status.isValid = ct.is_valid === true
          this.status.isInvalid = ct.is_invalid === true
          this.status.isPending = ct.is_pending === true

          this.customerConfirmedAt = ct.customer_confirmed_at || ''
          this.customerConfirmedByName = ct.customer_confirmed_by_name || ''
        }
      }
    }
  },
  methods: {
    ...mapActions('modal', ['MODAL_CORRECTION_TIME']),
    ...mapActions('ticket', [
      'TICKET_CORRECTION_TIME',
      'SET_PENDING_TIME_CORRECTION',
      'CLEAR_PENDING_TIME_CORRECTION'
    ]),
    close() {
      this.MODAL_CORRECTION_TIME(false)
    },
    handleCancel() {
      this.CLEAR_PENDING_TIME_CORRECTION()
      this.close()
    },
    toDatetimeLocal(dateString) {
      if (!dateString) return ''
      return dateString.split('.')[0].replace(' ', 'T').slice(0, 16)
    },
    toApiDatetime(datetimeLocal) {
      if (!datetimeLocal) return ''
      const withSpace = datetimeLocal.replace('T', ' ')
      return withSpace.length === 16 ? withSpace + ':00' : withSpace
    },
    formatDisplay(dateString) {
      if (!dateString) return ''
      const clean = dateString.split('.')[0].replace(' ', 'T')
      const date = new Date(clean)
      if (isNaN(date)) return dateString
      const day = String(date.getDate()).padStart(2, '0')
      const month = date.toLocaleString('en-GB', { month: 'short' })
      const year = date.getFullYear()
      const hh = String(date.getHours()).padStart(2, '0')
      const mm = String(date.getMinutes()).padStart(2, '0')
      return `${day} ${month} ${year} - ${hh}:${mm}`
    },
    validate() {
      const lc = this.form.loginCall ? new Date(this.form.loginCall) : null
      const st = this.form.start ? new Date(this.form.start) : null
      const dn = this.form.done ? new Date(this.form.done) : null

      // Only set error if field has been touched
      // loginCall should be before or equal to start and done
      this.errors.loginCall = this.touched.loginCall && lc && ((st && lc > st) || (dn && lc > dn))

      // start should be after or equal to loginCall and before or equal to done
      this.errors.start = this.touched.start && st && ((lc && st < lc) || (dn && st > dn))

      // done should be after or equal to loginCall and start
      this.errors.done = this.touched.done && dn && ((lc && dn < lc) || (st && dn < st))

      return !this.errors.loginCall && !this.errors.start && !this.errors.done
    },
    touchField(field) {
      this.touched[field] = true
      this.validate()
    },
    async handleSubmit() {
      if (!this.validate()) return

      // Store the time correction data in state instead of submitting immediately
      this.SET_PENDING_TIME_CORRECTION({
        ticketId: this.ticket.id,
        data: {
          customer_login_call_at: this.toApiDatetime(this.form.loginCall),
          customer_start_at: this.toApiDatetime(this.form.start),
          customer_done_at: this.toApiDatetime(this.form.done)
        }
      })

      this.close()
    }
  }
}
</script>
